<template>
  <div class="mx-auto pb-[70px]" :class="{ 'md:mr-[150px]': isDesktop, 'p-2': !isDesktop }">
    <h1 class="text-[30px] font-bold" :class="isDesktop ? 'mb-4' : 'mb-1'">Profile</h1>

    <Tabs default-value="personal" class="w-full">
      <TabsList class="mb-8">
        <TabsTrigger value="personal" class="px-0">Personal Details</TabsTrigger>
        <TabsTrigger value="payment">Payment Details</TabsTrigger>
      </TabsList>

      <TabsContent value="personal">
        <PersonalDetailsTab />
      </TabsContent>

      <TabsContent value="payment">
        <PaymentMethodsTab />
      </TabsContent>
    </Tabs>
  </div>
</template>

<script setup lang="ts">
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useBreakpoint } from '@/utils/useBreakPoint';
import PaymentMethodsTab from './PaymentMethodsTab.vue';
import PersonalDetailsTab from './PersonalDetailsTab.vue';

const { isDesktop } = useBreakpoint();
</script>
